import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[custom-modal-content]'
})
export class ModalContentWrapperDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
